webpackJsonp([136026132500526],{

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactstrap = __webpack_require__(10);
	
	__webpack_require__(745);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var limits = [["", "Free", "Essential", "Professional", "Enterprise"], ["Connections", 1, 4, 10, "No Limit"], ["Query Editors", 1, 4, 10, "No Limit"], ["Apex Editors", 1, 4, 10, "No Limit"], ["Rest Explorers", 1, 4, 10, "No Limit"], ["Soql Grid Batches Fetched at a time", 1, 4, 10, "No Limit"], ["CSV Viewer Max Records", 2000, 50000, 100000, "No Limit"], ["Soql Grid Max Records", 2000, 50000, 100000, "No Limit"], ["Soql Grid Max Edits per Save", "NA", 200, 1000, "No Limit"], ["Execution History Items", "NA", 50, 500, "No Limit"], ["Saved Scripts Items", "NA", 50, 500, "No Limit"], ["Recent Files Items", "NA", 50, 500, "No Limit"], ["Favorite Items", "NA", 50, 500, "No Limit"], ["Dataloader Profiles", "NA", "NA", 10, "No Limit"], ["Dataloader Max Records per Run", "NA", "NA", 50000, 1000000], ["Fake Data Profiles", "NA", "NA", 10, "No Limit"], ["Fake Data Max Records per Generation", "NA", "NA", 10000, "No Limit"]];
	
	var PricingColumn = function (_React$Component) {
	    _inherits(PricingColumn, _React$Component);
	
	    function PricingColumn(props) {
	        _classCallCheck(this, PricingColumn);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            discountsModal: false,
	            limitsModal: false
	        };
	
	        _this.toggleDiscounts = _this.toggleDiscounts.bind(_this);
	        _this.toggleLimits = _this.toggleLimits.bind(_this);
	        return _this;
	    }
	
	    PricingColumn.prototype.toggleDiscounts = function toggleDiscounts() {
	        this.setState({
	            discountsModal: !this.state.discountsModal,
	            limitsModal: false
	        });
	    };
	
	    PricingColumn.prototype.toggleLimits = function toggleLimits() {
	        this.setState({
	            discountsModal: false,
	            limitsModal: !this.state.limitsModal
	        });
	    };
	
	    PricingColumn.prototype.render = function render() {
	        var props = this.props;
	        return _react2.default.createElement(
	            'div',
	            { className: 'pricing-column col-md-6 col-lg-3 py-2 mx-auto' },
	            _react2.default.createElement(
	                'div',
	                { className: 'card font-title text-center' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'card-header bg-light' },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        props.name
	                    ),
	                    props.cost && _react2.default.createElement(
	                        'h4',
	                        { className: 'cost p-2' },
	                        '$',
	                        props.cost
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'per-description' },
	                        props.per
	                    ),
	                    _react2.default.createElement('br', null),
	                    props.cost && _react2.default.createElement(
	                        'a',
	                        { className: 'multiseat-discount', href: 'javascript:void(0)', onClick: this.toggleDiscounts },
	                        'Multi Seat Discount'
	                    ),
	                    _react2.default.createElement('br', null),
	                    props.buyUrl && _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { className: 'btn-buy btn btn-outline-primary my-2 my-sm-0 btn-sm', to: props.buyUrl },
	                        'Buy Now'
	                    ),
	                    _react2.default.createElement('br', null)
	                ),
	                _react2.default.createElement(
	                    'a',
	                    { className: 'view-limits', href: 'javascript:void(0)', onClick: this.toggleLimits },
	                    'View Limits'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'pricing-entries card-body text-center' },
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'p-0' },
	                        props.children
	                    )
	                ),
	                props.buyUrl && _react2.default.createElement(
	                    'div',
	                    { className: 'card-footer bg-light' },
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { className: 'btn-buy btn btn-outline-primary my-2 my-sm-0 btn-sm', to: props.buyUrl },
	                        'Buy Now'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _reactstrap.Modal,
	                { isOpen: this.state.discountsModal, fade: false, toggle: this.toggleDiscounts, className: this.props.className },
	                _react2.default.createElement(
	                    _reactstrap.ModalHeader,
	                    { toggle: this.toggleDiscounts },
	                    'Realfire ',
	                    props.name,
	                    ' - Discounts'
	                ),
	                _react2.default.createElement(
	                    _reactstrap.ModalBody,
	                    null,
	                    _react2.default.createElement(
	                        _reactstrap.Table,
	                        { striped: true, size: 'sm' },
	                        _react2.default.createElement(
	                            'thead',
	                            null,
	                            _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                    'th',
	                                    null,
	                                    'Seats'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    null,
	                                    'Discount'
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    null,
	                                    'Price'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tbody',
	                            null,
	                            _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    '1'
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    '0%'
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    '$',
	                                    props.cost
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    '2 - 4'
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    '10%'
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    '$',
	                                    Math.floor(props.cost * 0.9)
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    '5 - 9'
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    '15%'
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    '$',
	                                    Math.floor(props.cost * 0.85)
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    '10 - 19'
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    '20%'
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    '$',
	                                    Math.floor(props.cost * 0.8)
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    '20+'
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    '25%'
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    '$',
	                                    Math.floor(props.cost * 0.75)
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactstrap.ModalFooter,
	                    null,
	                    _react2.default.createElement(
	                        _reactstrap.Button,
	                        { className: 'my-2 my-sm-0 btn-sm', onClick: this.toggleDiscounts },
	                        'Close'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _reactstrap.Modal,
	                { isOpen: this.state.limitsModal, fade: false, toggle: this.toggleLimits, className: 'limits-modal', size: 'lg' },
	                _react2.default.createElement(
	                    _reactstrap.ModalHeader,
	                    { toggle: this.toggleLimits },
	                    'Realfire - Limits'
	                ),
	                _react2.default.createElement(
	                    _reactstrap.ModalBody,
	                    null,
	                    _react2.default.createElement(
	                        _reactstrap.Table,
	                        { striped: true, size: 'sm' },
	                        _react2.default.createElement(
	                            'thead',
	                            null,
	                            _react2.default.createElement(
	                                'tr',
	                                null,
	                                limits[0].map(function (header) {
	                                    return _react2.default.createElement(
	                                        'th',
	                                        null,
	                                        header
	                                    );
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tbody',
	                            null,
	                            limits.slice(1).map(function (feature) {
	                                return _react2.default.createElement(
	                                    'tr',
	                                    null,
	                                    feature.map(function (item) {
	                                        return _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            item
	                                        );
	                                    })
	                                );
	                            })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactstrap.ModalFooter,
	                    null,
	                    _react2.default.createElement(
	                        _reactstrap.Button,
	                        { className: 'my-2 my-sm-0 btn-sm', onClick: this.toggleLimits },
	                        'Close'
	                    )
	                )
	            )
	        );
	    };
	
	    return PricingColumn;
	}(_react2.default.Component);
	
	PricingColumn.propTypes = {
	    name: _propTypes2.default.string,
	    cost: _propTypes2.default.number,
	    per: _propTypes2.default.string,
	    buyUrl: _propTypes2.default.string
	};
	
	exports.default = PricingColumn;
	module.exports = exports['default'];

/***/ }),

/***/ 745:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(746);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PricingColumnEntry = function PricingColumnEntry(props) {
	    return _react2.default.createElement(
	        'li',
	        { className: 'p-2' },
	        props.name,
	        props.children,
	        props.new && _react2.default.createElement(
	            'sup',
	            { className: 'new-feature' },
	            ' New'
	        )
	    );
	};
	
	PricingColumnEntry.displayName = 'PricingColumnEntry';
	PricingColumnEntry.propTypes = {
	    name: _propTypes2.default.string,
	    new: _propTypes2.default.bool
	};
	
	exports.default = PricingColumnEntry;
	module.exports = exports['default'];

/***/ }),

/***/ 746:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _PricingColumn = __webpack_require__(388);
	
	var _PricingColumn2 = _interopRequireDefault(_PricingColumn);
	
	var _PricingColumnEntry = __webpack_require__(389);
	
	var _PricingColumnEntry2 = _interopRequireDefault(_PricingColumnEntry);
	
	__webpack_require__(758);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BuyPage = function (_Component) {
	    _inherits(BuyPage, _Component);
	
	    function BuyPage() {
	        _classCallCheck(this, BuyPage);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    BuyPage.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'pricing-container' },
	            _react2.default.createElement(_reactHelmet2.default, { title: 'Datasert - Realfire Pricing' }),
	            _react2.default.createElement(
	                'div',
	                { className: 'content' },
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Realfire Pricing'
	                ),
	                _react2.default.createElement(
	                    'h4',
	                    { className: 'try-string' },
	                    'Try Realfire Enterprise with all Features for 60 days'
	                ),
	                _react2.default.createElement(
	                    'h4',
	                    { className: 'try-string2' },
	                    'No Credit Card Required'
	                ),
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-outline-primary my-2 my-sm-0 btn-sm', href: '/products/realfire' },
	                        'Download Now'
	                    )
	                ),
	                _react2.default.createElement(
	                    'section',
	                    { className: 'pricing-style-2 bg-white p-3' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                _PricingColumn2.default,
	                                { name: 'Free' },
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Many features with limits' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Single Salesforce Connection' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Login using OAuth or Credentials' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Secure tokens/credentials with Master password' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'View Org Limits and Usage' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'View Objects List' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'View Object Details' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Browse Object Data' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Query Editor with support for Soql/Sosl' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Build Soqls easily with powerful Soql builder' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Run multiple Soql/Sosl Statements at a time' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'View Soql results in high performance Datagrid' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Fetch More batches' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Export Datagrid as Csv' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Apex Editor for Anonymous Apex' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Rest Apis Explorer' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'View CSV files in high performance CSV viewer' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Standard Object/Field Documentation' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Search for Objects' })
	                            ),
	                            _react2.default.createElement(
	                                _PricingColumn2.default,
	                                { name: 'Essential', cost: 11, per: 'per seat per month (billed annually)', buyUrl: '/products/realfire/buy?edition=essential' },
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'All features in Free Edition with higher limits plus:' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Soql Wildcard Fields' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Query Variables', 'new': true }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Async Soqls', 'new': true }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Schema Report', 'new': true }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'View Listview Records/Soql' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Object/Fields Summary Report' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Fields List Report' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Picklist Values Report' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'File Upload Manifest Generator' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'View Record Count of multiple objects' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Connection Colors' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Read-only Connections' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Ingrid Data editing' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'View Soql Results in Form View' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Export results into Excel', 'new': true }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Edit Custom Metadata Records' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'View Record Hierarchy' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Create/Edit CSV Files' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Execution History' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Saved Scripts' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Recent Files' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Favorites' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Search for Fields' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Easy Notes/Attachment Management' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'View Record History' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Explore and Query Tooling Objects' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Filter Records/Fields in Soql Datagrid' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Object Global Search' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Object/Field enrichment with Metadata Fields' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Field values Preview' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'View Object Limits' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Recent Objects View' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Favorites View' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Grid Filters' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Fields List Report' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Email Support' })
	                            ),
	                            _react2.default.createElement(
	                                _PricingColumn2.default,
	                                { name: 'Professional', cost: 42, per: 'per seat per month (billed annually)', buyUrl: '/products/realfire/buy?edition=professional' },
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'All features in Essential Edition with higher limits plus:' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Export results into Google Sheets', 'new': true }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'View/Search Metadata' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Compare Metadata' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Package XML Editor' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Fake Data Generation' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Debug Log Management and Viewer' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Debug Logs Streaming' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Bulk Schema Management' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Multi Connection Org Limits Report' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Multi Object Limits Report' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Parent/Child Browser', 'new': true }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Compare Data', 'new': true }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Metadata DB' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Org Limits Report' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Objects Limits Report' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Apex Looper', 'new': true }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'View Metadata Dependency', 'new': true }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Backup and Restore of Realfire Configuration' })
	                            ),
	                            _react2.default.createElement(
	                                _PricingColumn2.default,
	                                { name: 'Enterprise', cost: 84, per: 'per seat per month (billed annually)', buyUrl: '/products/realfire/buy?edition=enterprise' },
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'All features in Professional Edition with higher limits plus:' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Metadata Deployments', 'new': true }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Realfire Dataloader' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'DML Executions' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Mass Schema Updates' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Field Analysis' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Compare Profile/Permsets', 'new': true }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Mass Assigner Assigner' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Actions Toggler' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'List Views Management' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Roles Viewer' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'User Management' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Compare Users' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'View Reporting Hierarchy' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Import Users with Profile/Role/Manager Id resolution' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'View Setup Audit History' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'View Email Log' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'View Login History' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Page Layout Usage' }),
	                                _react2.default.createElement(_PricingColumnEntry2.default, { name: 'Scheduled Jobs', 'new': true })
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return BuyPage;
	}(_react.Component);
	
	exports.default = BuyPage;
	module.exports = exports['default'];

/***/ }),

/***/ 758:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-products-realfire-pricing-jsx-e99aea289dd52ec0152f.js